import { Select } from '@material-ui/core';
import React, { useState } from 'react';

const SelectDefination = () => {
  const [selectedOption, setSelectedOption] = useState('');

  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);
  };
  return (
    <div>
      <Select
        style={{ width: '150px' }}
        id="selectExample"
        value={selectedOption}
        onChange={handleSelectChange}
      >
        <option value="option1">Outstanding</option>
        <option value="option2">Excellent </option>
        <option value="option3"> Very Good</option>
        <option value="option4"> Good</option>
        <option value="option5">Above Average</option>
        <option value="option6">Average</option>
        <option value="option7">Pass</option>
        <option value="option8">Fail</option>
        <option value="option9">Repeat</option>
        <option value="option10">Absent</option>
        <option value="option11">Incomplete</option>
        <option value="option12">Satisfactory</option>
        <option value="option13">Unsatisfactory</option>
      </Select>
    </div>
  );
};

export default SelectDefination;
